/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createInventoryItem } from '../fn/inventory-items/create-inventory-item';
import { CreateInventoryItem$Params } from '../fn/inventory-items/create-inventory-item';
import { deleteInventoryItem } from '../fn/inventory-items/delete-inventory-item';
import { DeleteInventoryItem$Params } from '../fn/inventory-items/delete-inventory-item';
import { getInventoryItem } from '../fn/inventory-items/get-inventory-item';
import { GetInventoryItem$Params } from '../fn/inventory-items/get-inventory-item';
import { InventoryItemDto } from '../models/inventory-item-dto';
import { InventoryItemDtoPage } from '../models/inventory-item-dto-page';
import { listInventoryItems } from '../fn/inventory-items/list-inventory-items';
import { ListInventoryItems$Params } from '../fn/inventory-items/list-inventory-items';
import { updateInventoryItem } from '../fn/inventory-items/update-inventory-item';
import { UpdateInventoryItem$Params } from '../fn/inventory-items/update-inventory-item';

@Injectable({ providedIn: 'root' })
export class InventoryItemsApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listInventoryItems()` */
  static readonly ListInventoryItemsPath = '/v0/inventoryItems';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listInventoryItems()` instead.
   *
   * This method doesn't expect any request body.
   */
  listInventoryItems$Response(params?: ListInventoryItems$Params, context?: HttpContext): Observable<StrictHttpResponse<InventoryItemDtoPage>> {
    return listInventoryItems(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listInventoryItems$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listInventoryItems(params?: ListInventoryItems$Params, context?: HttpContext): Observable<InventoryItemDtoPage> {
    return this.listInventoryItems$Response(params, context).pipe(
      map((r: StrictHttpResponse<InventoryItemDtoPage>): InventoryItemDtoPage => r.body)
    );
  }

  /** Path part for operation `createInventoryItem()` */
  static readonly CreateInventoryItemPath = '/v0/inventoryItems';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createInventoryItem()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createInventoryItem$Response(params: CreateInventoryItem$Params, context?: HttpContext): Observable<StrictHttpResponse<InventoryItemDto>> {
    return createInventoryItem(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createInventoryItem$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createInventoryItem(params: CreateInventoryItem$Params, context?: HttpContext): Observable<InventoryItemDto> {
    return this.createInventoryItem$Response(params, context).pipe(
      map((r: StrictHttpResponse<InventoryItemDto>): InventoryItemDto => r.body)
    );
  }

  /** Path part for operation `getInventoryItem()` */
  static readonly GetInventoryItemPath = '/v0/inventoryItems/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getInventoryItem()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInventoryItem$Response(params: GetInventoryItem$Params, context?: HttpContext): Observable<StrictHttpResponse<InventoryItemDto>> {
    return getInventoryItem(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getInventoryItem$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInventoryItem(params: GetInventoryItem$Params, context?: HttpContext): Observable<InventoryItemDto> {
    return this.getInventoryItem$Response(params, context).pipe(
      map((r: StrictHttpResponse<InventoryItemDto>): InventoryItemDto => r.body)
    );
  }

  /** Path part for operation `updateInventoryItem()` */
  static readonly UpdateInventoryItemPath = '/v0/inventoryItems/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateInventoryItem()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateInventoryItem$Response(params: UpdateInventoryItem$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateInventoryItem(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateInventoryItem$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateInventoryItem(params: UpdateInventoryItem$Params, context?: HttpContext): Observable<void> {
    return this.updateInventoryItem$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteInventoryItem()` */
  static readonly DeleteInventoryItemPath = '/v0/inventoryItems/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteInventoryItem()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteInventoryItem$Response(params: DeleteInventoryItem$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteInventoryItem(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteInventoryItem$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteInventoryItem(params: DeleteInventoryItem$Params, context?: HttpContext): Observable<void> {
    return this.deleteInventoryItem$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
